import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import Home from 'components/home';

type Props = {
  data: Object,
};

const HomePage = ({ data }: Props) => {
  const {
    homeJson,
    siteJson,
    logoJson,
    socialMediaJson,
    cookieConsentJson,
    getInTouchJson,
    companyBadgesJson,
  } = data;

  return (
    <Website
      content={{
        ...homeJson,
        getInTouch: getInTouchJson,
        cookieConsent: cookieConsentJson,
        menu: siteJson?.content,
        logo: logoJson,
        socialMedia: socialMediaJson,
        companyBadges: companyBadgesJson,
      }}>
      <Layout>
        <Home />
      </Layout>
    </Website>
  );
};

export default HomePage;

export const query = graphql`
  query HomePageQuery {
    homeJson {
      hero {
        text
        title
        background {
          image
          video {
            caption
            lg
            sm
            type
            xs
          }
        }
      }
      models {
        subtitle
        title
        cards {
          id
          title
          content
          list {
            title
            items
          }
          buttonLabel
          buttonLink
        }
      }
      industries {
        title
        cards {
          id
          title
          content
          image
          imageSize
        }
        buttonLabel
        buttonLink
      }
      meta {
        description
        title
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    getInTouchJson {
      ...GetInTouchJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
    companyBadgesJson {
      ...CompanyBadgesJsonFragment
    }
  }
`;
